import { EpimsBaseEntityDto } from './epim-base.dto';
import { DocumentTypeDto } from './documenttype.dto';
export class DocumentDto extends EpimsBaseEntityDto {

  DocumentId: string;
  DocumentTitle: string;
  DocumentNo: string;
  DocumentURL: string;
  DocumentStatus: string;
  DocumentApprovalStatus: string;
  DocumentTypeId: string;
  DocumentTypeCodeId: string;
  DocumentIsPhysicallyFilled: boolean;
  DocumentRefNo: string;
  DocumentSecurityId: string;
  DocumentSecurityClassification: string;
  FilePath: string;
  FileName: string;
  FileType: string;
  OriginatedDepartment: string;
  DocumentMainRefNo: string;
  OriginatedModule: string;
  ShelveNo: string;
  DocumentDescription: string;
  OriginatedModuleSpecificId: string;
  DocumentDate: Date;
  DocumentDueDate: Date;
  DocumentTags: string;
  DocumentParentId: string;
  FileSize: string;
  FileUploadPath: string;
  DocumentPhysicalLocationId: string;
  DocumentType: DocumentTypeDto;

   

}